export interface ServiceCatalogItem {
  slug: string;
  name: string;
  shortName: string;
  icon: string;
  image: string;
  tagline: string;
  description: string;
  features: string[];
}

export const serviceCatalog: ServiceCatalogItem[] = [
  {
    slug: 'power-generation',
    name: 'Power Generation & Generators',
    shortName: 'Power Generation',
    icon: 'ri-flashlight-line',
    image: `${import.meta.env.BASE_URL}images/afb6ac41de6c3dcf.webp`,
    tagline: 'Reliable power, around the clock',
    description:
      'Sales, installation and round-the-clock servicing of generators and power systems for homes, businesses and industry — sized correctly and built to run when it matters most.',
    features: [
      'Generator sales, supply & sizing',
      'Turnkey installation & commissioning',
      'Preventive maintenance contracts',
      '24/7 emergency repair & support',
    ],
  },
  {
    slug: 'fire-safety',
    name: 'Fire Safety & Firefighting Solutions',
    shortName: 'Fire Safety',
    icon: 'ri-fire-line',
    image: `${import.meta.env.BASE_URL}images/6da781b727a5341f.webp`,
    tagline: 'Protection you can count on',
    description:
      'Certified fire detection, suppression and firefighting systems designed to protect people, property and operations — assessed, installed and maintained to recognised standards.',
    features: [
      'Fire risk assessments & compliance audits',
      'Detection, alarm & warning systems',
      'Suppression & extinguishing systems',
      'Firefighting equipment supply & training',
    ],
  },
  {
    slug: 'engineering-services',
    name: 'Engineering & Technical Services',
    shortName: 'Engineering Services',
    icon: 'ri-tools-line',
    image: `${import.meta.env.BASE_URL}images/5dd5394b6929a2d4.jpg`,
    tagline: 'Expertise that keeps operations moving',
    description:
      'End-to-end engineering, installation and maintenance services supporting industries, institutions and infrastructure across Nigeria.',
    features: [
      'Electrical & mechanical engineering',
      'Industrial installation & retrofits',
      'Planned maintenance programmes',
      'Technical consultancy, design & documentation',
    ],
  },
  {
    slug: 'trading-distribution',
    name: 'Trading & Distribution',
    shortName: 'Trading & Distribution',
    icon: 'ri-ship-2-line',
    image: `${import.meta.env.BASE_URL}images/18fae3f7c0033a93.jpg`,
    tagline: 'Genuine equipment, delivered nationwide',
    description:
      'A trusted distribution network bringing quality equipment and verified brands to businesses across Nigeria, backed by dependable supply chains.',
    features: [
      'Genuine equipment & spare parts supply',
      'Nationwide distribution network',
      'Authorised brand partnerships',
      'Supply chain, sourcing & logistics support',
    ],
  },
];

export interface ProcessStep {
  step: string;
  title: string;
  description: string;
  icon: string;
}

export const deliveryProcess: ProcessStep[] = [
  {
    step: '01',
    title: 'Consultation & Site Survey',
    description:
      'We start by understanding your operation, then assess the site to define the right technical scope and requirements.',
    icon: 'ri-chat-1-line',
  },
  {
    step: '02',
    title: 'Design & Proposal',
    description:
      'Our engineers design a solution and prepare a clear proposal — the right specification, timeline and cost, with no surprises.',
    icon: 'ri-draft-line',
  },
  {
    step: '03',
    title: 'Professional Installation',
    description:
      'Certified technicians install and commission your solution, working to recognised standards and minimising disruption.',
    icon: 'ri-hammer-line',
  },
  {
    step: '04',
    title: 'Support & Maintenance',
    description:
      'After handover we stay with you — planned maintenance, genuine parts and responsive support keep everything running.',
    icon: 'ri-customer-service-2-line',
  },
];

export interface Industry {
  name: string;
  icon: string;
}

export const industries: Industry[] = [
  { name: 'Manufacturing & Industrial', icon: 'ri-building-2-line' },
  { name: 'Oil, Gas & Energy', icon: 'ri-gas-station-line' },
  { name: 'Banking & Finance', icon: 'ri-bank-line' },
  { name: 'Healthcare & Hospitals', icon: 'ri-heart-pulse-line' },
  { name: 'Government & Public Sector', icon: 'ri-government-line' },
  { name: 'Retail & Commercial', icon: 'ri-store-2-line' },
  { name: 'Hospitality & Leisure', icon: 'ri-hotel-line' },
  { name: 'Education & Institutions', icon: 'ri-graduation-cap-line' },
];

export interface ServiceFaq {
  question: string;
  answer: string;
}

export const serviceFaqs: ServiceFaq[] = [
  {
    question: 'Which regions of Nigeria do you cover?',
    answer:
      'We serve businesses and institutions across multiple states nationwide, supported by a responsive sales, installation and after-sales support network.',
  },
  {
    question: 'Do you offer maintenance after installation?',
    answer:
      'Yes. We offer planned preventive maintenance and responsive after-sales support so your equipment keeps performing long after handover.',
  },
  {
    question: 'Are your fire safety systems certified?',
    answer:
      'Our fire detection and suppression solutions are designed and installed to recognised fire safety standards, with compliance audits and documentation provided.',
  },
  {
    question: 'Can you supply generators and spare parts directly?',
    answer:
      'We supply genuine generators, equipment and spare parts through our distribution network and authorised brand partnerships.',
  },
  {
    question: 'How quickly can you respond to an emergency?',
    answer:
      'We operate 24/7 service and maintenance support, with regional teams positioned to respond quickly to urgent breakdowns.',
  },
  {
    question: 'Do you work with both private and public sector clients?',
    answer:
      'Yes. We partner with corporate, industrial and institutional clients across the private and public sectors.',
  },
];